import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/updates/regions")({
  beforeLoad() {
    return { pageName: "All Organizations" };
  }
});
